import {PartyRole} from '@sollapay/enums';

import {StandardTrustType} from './trust-type.strategy';

import type {TrustPurpose} from '@sollapay/enums';

/** Used when a trust account has no purpose set. Conservative default: full payment allowed. */
class DefaultTrustType extends StandardTrustType {
  readonly purpose: TrustPurpose | null = null;
  readonly maxCollectionPercentage = 100;

  getBuyerPartyRoles(): PartyRole[] {
    return [PartyRole.BUYER];
  }
}

export const defaultTrustType = new DefaultTrustType();
